import { render, staticRenderFns } from "./WechatPay.vue?vue&type=template&id=f446e024&scoped=true&"
import script from "./WechatPay.vue?vue&type=script&lang=js&"
export * from "./WechatPay.vue?vue&type=script&lang=js&"
import style0 from "./WechatPay.vue?vue&type=style&index=0&id=f446e024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f446e024",
  null
  
)

export default component.exports